
import Vue from 'vue'

const locales = {keys(){return []}}
global['____AD7F8B3____'] = true;
delete global['____AD7F8B3____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"uni-app","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8","autoscan":true},"condition":{"current":0,"list":[{"name":"健康医生","path":"pagesChat/group/index","query":"scene=1853&type=student&bind=1"},{"name":"登陆","path":"pages/login/login"},{"name":"登陆b","path":"pagesUser/login/index"},{"name":"基本信息","path":"pagesUser/modifyInfo/index"},{"name":"我的","path":"pages/my/index"},{"name":"搜索","path":"pagesChat/group/search"},{"name":"分享我的健康日程","path":"pages/shareMy/index","query":"encryptUserId=37cfede5f08e378a"},{"name":"demo","path":"pagesUser/demo/chizi","query":"encryptUserId=37cfede5f08e378a"},{"name":"五师首页","path":"pagesChat/doctor/index","query":"pageType=INVITE_ALERT&consultId=29005&isManualInvite=1&inviterId=563&groupId=hb_qa@15436&type=RECEIVES"},{"name":"群设置","path":"pagesChat/settings/index","query":""},{"name":"提醒","path":"pagesUser/newRemind/index","query":""},{"name":"日常监测","path":"pagesMonitor/monitor/index","query":""},{"name":"体脂秤","path":"pagesMonitor/monitor/device/measure","query":""},{"name":"体检报告","path":"pagesUser/report/examination"},{"name":"视频列表","path":"pagesUser/videoList"}]}};
global.__uniConfig.compilerVersion = '3.99';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__AD7F8B3';
global.__uniConfig.appName = 'wxapp';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"/pro/fiveteachersH5/"};
global.__uniConfig.publicPath = "/pro/fiveteachersH5/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":500,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-register-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pages/register/index"+'.vue')), 'pages-register-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pages/my/index"+'.vue')), 'pages-my-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-message-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pages/message/index"+'.vue')), 'pages-message-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pages/login/login"+'.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shareMy-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pages/shareMy/index"+'.vue')), 'pages-shareMy-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-modifyInfo-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/modifyInfo/index"+'.vue')), 'pagesUser-modifyInfo-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-privacyPolicy-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/privacyPolicy/index"+'.vue')), 'pagesUser-privacyPolicy-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-demo-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/demo/index"+'.vue')), 'pagesUser-demo-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-remind-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/remind/index"+'.vue')), 'pagesUser-remind-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-newRemind-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/newRemind/index"+'.vue')), 'pagesUser-newRemind-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-demo-chizi', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/demo/chizi"+'.vue')), 'pagesUser-demo-chizi'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-webView-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/webView/index"+'.vue')), 'pagesUser-webView-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-webView-iframe', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/webView/iframe"+'.vue')), 'pagesUser-webView-iframe'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-webView-pdf', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/webView/pdf"+'.vue')), 'pagesUser-webView-pdf'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-educationAnswer-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/educationAnswer/index"+'.vue')), 'pagesUser-educationAnswer-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/login/index"+'.vue')), 'pagesUser-login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-report-examination', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/report/examination"+'.vue')), 'pagesUser-report-examination'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-report-programme', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/report/programme"+'.vue')), 'pagesUser-report-programme'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-videoList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesUser/videoList"+'.vue')), 'pagesUser-videoList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-group-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/group/index"+'.vue')), 'pagesChat-group-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-group-history', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/group/history"+'.vue')), 'pagesChat-group-history'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-group-search', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/group/search"+'.vue')), 'pagesChat-group-search'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-doctor-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/doctor/index"+'.vue')), 'pagesChat-doctor-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-doctor-chat', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/doctor/chat"+'.vue')), 'pagesChat-doctor-chat'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-videoPlay-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/videoPlay/index"+'.vue')), 'pagesChat-videoPlay-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-settings-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/settings/index"+'.vue')), 'pagesChat-settings-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-settings-qrcode', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/settings/qrcode"+'.vue')), 'pagesChat-settings-qrcode'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-settings-administrators', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/settings/administrators"+'.vue')), 'pagesChat-settings-administrators'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-settings-scanResult', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/settings/scanResult"+'.vue')), 'pagesChat-settings-scanResult'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-settings-moreUserList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/settings/moreUserList"+'.vue')), 'pagesChat-settings-moreUserList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-notes-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/notes/index"+'.vue')), 'pagesChat-notes-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-setName-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/setName/index"+'.vue')), 'pagesChat-setName-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-setName-setGroupName', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/setName/setGroupName"+'.vue')), 'pagesChat-setName-setGroupName'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesChat-notification-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesChat/notification/index"+'.vue')), 'pagesChat-notification-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesEcharts-monitor-baseInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesEcharts/monitor/baseInfo"+'.vue')), 'pagesEcharts-monitor-baseInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesEcharts-monitor-bloodPressure', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesEcharts/monitor/bloodPressure"+'.vue')), 'pagesEcharts-monitor-bloodPressure'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesEcharts-monitor-bloodSugar', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesEcharts/monitor/bloodSugar"+'.vue')), 'pagesEcharts-monitor-bloodSugar'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesEcharts-monitor-urineMonitor', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesEcharts/monitor/urineMonitor"+'.vue')), 'pagesEcharts-monitor-urineMonitor'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesEcharts-monitor-return', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesEcharts/monitor/return"+'.vue')), 'pagesEcharts-monitor-return'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesEcharts-monitor-pressure', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesEcharts/monitor/pressure"+'.vue')), 'pagesEcharts-monitor-pressure'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesEcharts-trends-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesEcharts/trends/login"+'.vue')), 'pagesEcharts-trends-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesEcharts-trends-bloodSugar', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesEcharts/trends/bloodSugar"+'.vue')), 'pagesEcharts-trends-bloodSugar'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesEcharts-monitor-compare', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesEcharts/monitor/compare"+'.vue')), 'pagesEcharts-monitor-compare'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-calendar-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/calendar/index"+'.vue')), 'pagesH5-calendar-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-appEcharts-bloodSugar', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/appEcharts/bloodSugar"+'.vue')), 'pagesH5-appEcharts-bloodSugar'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-smartHome-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/smartHome/index"+'.vue')), 'pagesH5-smartHome-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-dietRecord-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/dietRecord/index"+'.vue')), 'pagesH5-dietRecord-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-dietRecord-record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/dietRecord/record"+'.vue')), 'pagesH5-dietRecord-record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-dietRecord-dietaryReport', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/dietRecord/dietaryReport"+'.vue')), 'pagesH5-dietRecord-dietaryReport'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-dietRecord-thesamedayRecordList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/dietRecord/thesamedayRecordList"+'.vue')), 'pagesH5-dietRecord-thesamedayRecordList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-dietRecord-thesamedayRecordIndetify', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/dietRecord/thesamedayRecordIndetify"+'.vue')), 'pagesH5-dietRecord-thesamedayRecordIndetify'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/index"+'.vue')), 'pagesH5-userSettings-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-chatSetting', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/chatSetting"+'.vue')), 'pagesH5-userSettings-chatSetting'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-customerInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/customerInfo"+'.vue')), 'pagesH5-userSettings-customerInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-download-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/download/index"+'.vue')), 'pagesH5-download-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-healthAndWellnessPlan', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/healthAndWellnessPlan"+'.vue')), 'pagesH5-userSettings-healthAndWellnessPlan'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-healthReport', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/healthReport"+'.vue')), 'pagesH5-userSettings-healthReport'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-planInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/planInfo"+'.vue')), 'pagesH5-userSettings-planInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-planContent', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/planContent"+'.vue')), 'pagesH5-userSettings-planContent'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-qrcode', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/qrcode"+'.vue')), 'pagesH5-userSettings-qrcode'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-groupReport', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/groupReport"+'.vue')), 'pagesH5-userSettings-groupReport'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-facialAndTongueDiagnosis', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/facialAndTongueDiagnosis"+'.vue')), 'pagesH5-userSettings-facialAndTongueDiagnosis'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-facialAndTongueDiagnosisTwo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/facialAndTongueDiagnosisTwo"+'.vue')), 'pagesH5-userSettings-facialAndTongueDiagnosisTwo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-wuYang-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/wuYang/index"+'.vue')), 'pagesH5-wuYang-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-intelligentEvaluation', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/intelligentEvaluation"+'.vue')), 'pagesH5-userSettings-intelligentEvaluation'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-reportList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/reportList"+'.vue')), 'pagesH5-userSettings-reportList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-plan-weightLoss', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/plan/weightLoss"+'.vue')), 'pagesH5-plan-weightLoss'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-plan-diet', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/plan/diet"+'.vue')), 'pagesH5-plan-diet'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-orderConfirm-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/orderConfirm/index"+'.vue')), 'pagesH5-orderConfirm-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-familyChart-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/familyChart/index"+'.vue')), 'pagesH5-familyChart-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-familyChart-addressBook', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/familyChart/addressBook"+'.vue')), 'pagesH5-familyChart-addressBook'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-familyChart-selectRelationship', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/familyChart/selectRelationship"+'.vue')), 'pagesH5-familyChart-selectRelationship'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-familyChart-editInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/familyChart/editInfo"+'.vue')), 'pagesH5-familyChart-editInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-InviteFriends-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/InviteFriends/index"+'.vue')), 'pagesH5-InviteFriends-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-InviteFriends-addressBook', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/InviteFriends/addressBook"+'.vue')), 'pagesH5-InviteFriends-addressBook'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/index"+'.vue')), 'pagesH5-demo-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-alarm', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/alarm"+'.vue')), 'pagesH5-demo-alarm'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-weight', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/weight"+'.vue')), 'pagesH5-demo-weight'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-familyHealth', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/familyHealth"+'.vue')), 'pagesH5-demo-familyHealth'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-play', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/play"+'.vue')), 'pagesH5-demo-play'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-schedule', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/schedule"+'.vue')), 'pagesH5-demo-schedule'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-kouQiang', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/kouQiang"+'.vue')), 'pagesH5-demo-kouQiang'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-nuanXin', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/nuanXin"+'.vue')), 'pagesH5-demo-nuanXin'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-jianKang', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/jianKang"+'.vue')), 'pagesH5-demo-jianKang'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-pingPlay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/pingPlay"+'.vue')), 'pagesH5-demo-pingPlay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-jianYa', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/jianYa"+'.vue')), 'pagesH5-demo-jianYa'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-taskManage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/taskManage"+'.vue')), 'pagesH5-demo-taskManage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-userPortrait', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/userPortrait"+'.vue')), 'pagesH5-demo-userPortrait'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-demo-bloodResultPop', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/demo/bloodResultPop"+'.vue')), 'pagesH5-demo-bloodResultPop'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-hardware-resultPressure', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/hardware/resultPressure"+'.vue')), 'pagesH5-hardware-resultPressure'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-registration-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/registration/index"+'.vue')), 'pagesH5-registration-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-registration-recommendedDoctor', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/registration/recommendedDoctor"+'.vue')), 'pagesH5-registration-recommendedDoctor'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-aiReasoning-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/aiReasoning/index"+'.vue')), 'pagesH5-aiReasoning-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-registration-visitor', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/registration/visitor"+'.vue')), 'pagesH5-registration-visitor'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-registration-visitorAdd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/registration/visitorAdd"+'.vue')), 'pagesH5-registration-visitorAdd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-registration-customInfoEdit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/registration/customInfoEdit"+'.vue')), 'pagesH5-registration-customInfoEdit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-registration-signing', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/registration/signing"+'.vue')), 'pagesH5-registration-signing'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-appointment-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/appointment/index"+'.vue')), 'pagesH5-appointment-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-medicalExaminationReport-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/medicalExaminationReport/index"+'.vue')), 'pagesH5-medicalExaminationReport-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-intelligentReservation-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/intelligentReservation/index"+'.vue')), 'pagesH5-intelligentReservation-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-intelligentReservation-search', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/intelligentReservation/search"+'.vue')), 'pagesH5-intelligentReservation-search'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-aboutUs', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/aboutUs"+'.vue')), 'pagesH5-userSettings-aboutUs'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-cancelAccount', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/cancelAccount"+'.vue')), 'pagesH5-userSettings-cancelAccount'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-userSettings-cancellation', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/userSettings/cancellation"+'.vue')), 'pagesH5-userSettings-cancellation'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-interventionPlan-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/interventionPlan/index"+'.vue')), 'pagesH5-interventionPlan-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-evaluating-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/evaluating/index"+'.vue')), 'pagesH5-evaluating-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-evaluating-report', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/evaluating/report"+'.vue')), 'pagesH5-evaluating-report'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-evaluating-reportDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/evaluating/reportDetail"+'.vue')), 'pagesH5-evaluating-reportDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesH5-videoPlay-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesH5/videoPlay/index"+'.vue')), 'pagesH5-videoPlay-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesFriend-addressBook-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesFriend/addressBook/index"+'.vue')), 'pagesFriend-addressBook-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesFriend-addressBook-groupList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesFriend/addressBook/groupList"+'.vue')), 'pagesFriend-addressBook-groupList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesFriend-notification-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesFriend/notification/index"+'.vue')), 'pagesFriend-notification-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesFriend-addFriends-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesFriend/addFriends/index"+'.vue')), 'pagesFriend-addFriends-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesFriend-addFriends-info', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesFriend/addFriends/info"+'.vue')), 'pagesFriend-addFriends-info'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesFriend-addFriends-applay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesFriend/addFriends/applay"+'.vue')), 'pagesFriend-addFriends-applay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/index"+'.vue')), 'pagesMonitor-monitor-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-add-blood-pressure', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/add-blood-pressure"+'.vue')), 'pagesMonitor-monitor-add-blood-pressure'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-add-blood-sugar', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/add-blood-sugar"+'.vue')), 'pagesMonitor-monitor-add-blood-sugar'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-add-drug', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/add-drug"+'.vue')), 'pagesMonitor-monitor-add-drug'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-add-medicine', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/add-medicine"+'.vue')), 'pagesMonitor-monitor-add-medicine'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-edit-baseinfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/edit-baseinfo"+'.vue')), 'pagesMonitor-monitor-edit-baseinfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-add-weight', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/add-weight"+'.vue')), 'pagesMonitor-monitor-add-weight'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-add-waist', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/add-waist"+'.vue')), 'pagesMonitor-monitor-add-waist'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-add-urine-monitor', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/add-urine-monitor"+'.vue')), 'pagesMonitor-monitor-add-urine-monitor'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-record-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/record-list"+'.vue')), 'pagesMonitor-monitor-record-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-device-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/device/index"+'.vue')), 'pagesMonitor-monitor-device-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-device-measure', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/device/measure"+'.vue')), 'pagesMonitor-monitor-device-measure'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-result-body-girth', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/result/body-girth"+'.vue')), 'pagesMonitor-monitor-result-body-girth'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-result-weight', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/result/weight"+'.vue')), 'pagesMonitor-monitor-result-weight'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-result-bodyMetrics', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/result/bodyMetrics"+'.vue')), 'pagesMonitor-monitor-result-bodyMetrics'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-result-blood-weight', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/result/blood-weight"+'.vue')), 'pagesMonitor-monitor-result-blood-weight'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-result-blood-sugar', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/result/blood-sugar"+'.vue')), 'pagesMonitor-monitor-result-blood-sugar'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMonitor-monitor-result-blood-pressure', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/workspace/IntelligentFiveTeachersWx_OOm1/src/pagesMonitor/monitor/result/blood-pressure"+'.vue')), 'pagesMonitor-monitor-result-blood-pressure'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/register/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"挂号"})
      },
      [
        createElement('pages-register-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-register-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/register/index',
  windowTop:44
}
},
{
path: '/pages/my/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的","navigationBarBackgroundColor":"#C2DDFF"})
      },
      [
        createElement('pages-my-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/index',
  windowTop:44
}
},
{
path: '/pages/message/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"消息","navigationBarBackgroundColor":"#D9E8FB"})
      },
      [
        createElement('pages-message-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-message-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/message/index',
  windowTop:44
}
},
{
path: '/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录","enablePullDownRefresh":false,"navigationStyle":"custom","navigationBarBackgroundColor":"#DBE9FC"})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
  windowTop:0
}
},
{
path: '/pages/shareMy/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationBarBackgroundColor":"#C2DDFF"})
      },
      [
        createElement('pages-shareMy-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shareMy-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shareMy/index',
  windowTop:44
}
},
{
path: '/pagesUser/modifyInfo/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"基本信息","enablePullDownRefresh":false,"navigationBarBackgroundColor":"#DBE9FC"})
      },
      [
        createElement('pagesUser-modifyInfo-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-modifyInfo-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/modifyInfo/index',
  windowTop:44
}
},
{
path: '/pagesUser/privacyPolicy/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false,"titleNView":false,"navigationBarBackgroundColor":"#DBE9FC"})
      },
      [
        createElement('pagesUser-privacyPolicy-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-privacyPolicy-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/privacyPolicy/index',
  windowTop:0
}
},
{
path: '/pagesUser/demo/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"demo"})
      },
      [
        createElement('pagesUser-demo-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-demo-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/demo/index',
  windowTop:44
}
},
{
path: '/pagesUser/remind/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的提醒","navigationBarBackgroundColor":"#DBE9FC"})
      },
      [
        createElement('pagesUser-remind-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-remind-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/remind/index',
  windowTop:44
}
},
{
path: '/pagesUser/newRemind/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"创建提醒"})
      },
      [
        createElement('pagesUser-newRemind-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-newRemind-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/newRemind/index',
  windowTop:44
}
},
{
path: '/pagesUser/demo/chizi',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"chizi"})
      },
      [
        createElement('pagesUser-demo-chizi', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-demo-chizi',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/demo/chizi',
  windowTop:44
}
},
{
path: '/pagesUser/webView/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationBarBackgroundColor":"#FFF"})
      },
      [
        createElement('pagesUser-webView-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-webView-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/webView/index',
  windowTop:44
}
},
{
path: '/pagesUser/webView/iframe',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pagesUser-webView-iframe', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-webView-iframe',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/webView/iframe',
  windowTop:44
}
},
{
path: '/pagesUser/webView/pdf',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pagesUser-webView-pdf', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-webView-pdf',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/webView/pdf',
  windowTop:44
}
},
{
path: '/pagesUser/educationAnswer/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"健康宣教"})
      },
      [
        createElement('pagesUser-educationAnswer-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-educationAnswer-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/educationAnswer/index',
  windowTop:44
}
},
{
path: '/pagesUser/login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录","enablePullDownRefresh":false,"navigationBarBackgroundColor":"#DBE9FC"})
      },
      [
        createElement('pagesUser-login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-login-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/login/index',
  windowTop:44
}
},
{
path: '/pagesUser/report/examination',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"体检报告","navigationBarBackgroundColor":"#DBE9FC"})
      },
      [
        createElement('pagesUser-report-examination', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-report-examination',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/report/examination',
  windowTop:44
}
},
{
path: '/pagesUser/report/programme',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"健康方案","navigationBarBackgroundColor":"#DBE9FC"})
      },
      [
        createElement('pagesUser-report-programme', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-report-programme',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/report/programme',
  windowTop:44
}
},
{
path: '/pagesUser/videoList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pagesUser-videoList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-videoList',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/videoList',
  windowTop:44
}
},
{
path: '/pagesChat/group/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"健康医生","enablePullDownRefresh":false,"navigationStyle":"custom","navigationBarBackgroundColor":"#F4F8FF"})
      },
      [
        createElement('pagesChat-group-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-group-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/group/index',
  windowTop:0
}
},
{
path: '/pagesChat/group/history',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"历史消息","navigationBarBackgroundColor":"#D9E8FB"})
      },
      [
        createElement('pagesChat-group-history', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-group-history',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/group/history',
  windowTop:44
}
},
{
path: '/pagesChat/group/search',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索","navigationBarBackgroundColor":"#D9E8FB"})
      },
      [
        createElement('pagesChat-group-search', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-group-search',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/group/search',
  windowTop:44
}
},
{
path: '/pagesChat/doctor/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom"})
      },
      [
        createElement('pagesChat-doctor-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-doctor-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/doctor/index',
  windowTop:0
}
},
{
path: '/pagesChat/doctor/chat',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom"})
      },
      [
        createElement('pagesChat-doctor-chat', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-doctor-chat',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/doctor/chat',
  windowTop:0
}
},
{
path: '/pagesChat/videoPlay/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pagesChat-videoPlay-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-videoPlay-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/videoPlay/index',
  windowTop:44
}
},
{
path: '/pagesChat/settings/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom"})
      },
      [
        createElement('pagesChat-settings-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-settings-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/settings/index',
  windowTop:0
}
},
{
path: '/pagesChat/settings/qrcode',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"群二维码","navigationBarBackgroundColor":"#fff"})
      },
      [
        createElement('pagesChat-settings-qrcode', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-settings-qrcode',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/settings/qrcode',
  windowTop:44
}
},
{
path: '/pagesChat/settings/administrators',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加群管理员"})
      },
      [
        createElement('pagesChat-settings-administrators', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-settings-administrators',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/settings/administrators',
  windowTop:44
}
},
{
path: '/pagesChat/settings/scanResult',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"加入群组"})
      },
      [
        createElement('pagesChat-settings-scanResult', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-settings-scanResult',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/settings/scanResult',
  windowTop:44
}
},
{
path: '/pagesChat/settings/moreUserList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"查看群成员"})
      },
      [
        createElement('pagesChat-settings-moreUserList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-settings-moreUserList',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/settings/moreUserList',
  windowTop:44
}
},
{
path: '/pagesChat/notes/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pagesChat-notes-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-notes-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/notes/index',
  windowTop:44
}
},
{
path: '/pagesChat/setName/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationBarBackgroundColor":"#fff"})
      },
      [
        createElement('pagesChat-setName-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-setName-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/setName/index',
  windowTop:44
}
},
{
path: '/pagesChat/setName/setGroupName',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改群聊名称","navigationBarBackgroundColor":"#fff"})
      },
      [
        createElement('pagesChat-setName-setGroupName', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-setName-setGroupName',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/setName/setGroupName',
  windowTop:44
}
},
{
path: '/pagesChat/notification/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"群公告","navigationBarBackgroundColor":"#fff"})
      },
      [
        createElement('pagesChat-notification-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesChat-notification-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesChat/notification/index',
  windowTop:44
}
},
{
path: '/pagesEcharts/monitor/baseInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"体重管理","navigationBarBackgroundColor":"#D9E8FC","navigationStyle":"custom"})
      },
      [
        createElement('pagesEcharts-monitor-baseInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesEcharts-monitor-baseInfo',
  isNVue:false,maxWidth:0,
  pagePath:'pagesEcharts/monitor/baseInfo',
  windowTop:0
}
},
{
path: '/pagesEcharts/monitor/bloodPressure',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"血压记录","navigationBarBackgroundColor":"#D9E8FC","navigationStyle":"custom"})
      },
      [
        createElement('pagesEcharts-monitor-bloodPressure', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesEcharts-monitor-bloodPressure',
  isNVue:false,maxWidth:0,
  pagePath:'pagesEcharts/monitor/bloodPressure',
  windowTop:0
}
},
{
path: '/pagesEcharts/monitor/bloodSugar',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"血糖-指血模式","navigationBarBackgroundColor":"#D9E8FC","navigationStyle":"custom"})
      },
      [
        createElement('pagesEcharts-monitor-bloodSugar', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesEcharts-monitor-bloodSugar',
  isNVue:false,maxWidth:0,
  pagePath:'pagesEcharts/monitor/bloodSugar',
  windowTop:0
}
},
{
path: '/pagesEcharts/monitor/urineMonitor',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"记录","navigationBarBackgroundColor":"#D9E8FC","navigationStyle":"custom"})
      },
      [
        createElement('pagesEcharts-monitor-urineMonitor', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesEcharts-monitor-urineMonitor',
  isNVue:false,maxWidth:0,
  pagePath:'pagesEcharts/monitor/urineMonitor',
  windowTop:0
}
},
{
path: '/pagesEcharts/monitor/return',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pagesEcharts-monitor-return', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesEcharts-monitor-return',
  isNVue:false,maxWidth:0,
  pagePath:'pagesEcharts/monitor/return',
  windowTop:44
}
},
{
path: '/pagesEcharts/monitor/pressure',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"压力记录","navigationBarBackgroundColor":"#D9E8FC","navigationStyle":"custom"})
      },
      [
        createElement('pagesEcharts-monitor-pressure', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesEcharts-monitor-pressure',
  isNVue:false,maxWidth:0,
  pagePath:'pagesEcharts/monitor/pressure',
  windowTop:0
}
},
{
path: '/pagesEcharts/trends/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录"})
      },
      [
        createElement('pagesEcharts-trends-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesEcharts-trends-login',
  isNVue:false,maxWidth:0,
  pagePath:'pagesEcharts/trends/login',
  windowTop:44
}
},
{
path: '/pagesEcharts/trends/bloodSugar',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"血糖记录","navigationStyle":"custom"})
      },
      [
        createElement('pagesEcharts-trends-bloodSugar', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesEcharts-trends-bloodSugar',
  isNVue:false,maxWidth:0,
  pagePath:'pagesEcharts/trends/bloodSugar',
  windowTop:0
}
},
{
path: '/pagesEcharts/monitor/compare',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"数据对比","navigationBarBackgroundColor":"#fff","navigationStyle":"custom"})
      },
      [
        createElement('pagesEcharts-monitor-compare', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesEcharts-monitor-compare',
  isNVue:false,maxWidth:0,
  pagePath:'pagesEcharts/monitor/compare',
  windowTop:0
}
},
{
path: '/pagesH5/calendar/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"日程","titleNView":false})
      },
      [
        createElement('pagesH5-calendar-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-calendar-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/calendar/index',
  windowTop:0
}
},
{
path: '/pagesH5/appEcharts/bloodSugar',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"血糖","titleNView":false})
      },
      [
        createElement('pagesH5-appEcharts-bloodSugar', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-appEcharts-bloodSugar',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/appEcharts/bloodSugar',
  windowTop:0
}
},
{
path: '/pagesH5/smartHome/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智能家居","titleNView":false})
      },
      [
        createElement('pagesH5-smartHome-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-smartHome-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/smartHome/index',
  windowTop:0
}
},
{
path: '/pagesH5/dietRecord/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"饮食记录","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-dietRecord-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-dietRecord-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/dietRecord/index',
  windowTop:0
}
},
{
path: '/pagesH5/dietRecord/record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"手动记录","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-dietRecord-record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-dietRecord-record',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/dietRecord/record',
  windowTop:0
}
},
{
path: '/pagesH5/dietRecord/dietaryReport',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"营养师点评","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-dietRecord-dietaryReport', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-dietRecord-dietaryReport',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/dietRecord/dietaryReport',
  windowTop:0
}
},
{
path: '/pagesH5/dietRecord/thesamedayRecordList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"饮食记录","navigationBarBackgroundColor":"#fff"})
      },
      [
        createElement('pagesH5-dietRecord-thesamedayRecordList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-dietRecord-thesamedayRecordList',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/dietRecord/thesamedayRecordList',
  windowTop:44
}
},
{
path: '/pagesH5/dietRecord/thesamedayRecordIndetify',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"饮食记录","navigationBarBackgroundColor":"#fff"})
      },
      [
        createElement('pagesH5-dietRecord-thesamedayRecordIndetify', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-dietRecord-thesamedayRecordIndetify',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/dietRecord/thesamedayRecordIndetify',
  windowTop:44
}
},
{
path: '/pagesH5/userSettings/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-userSettings-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/index',
  windowTop:0
}
},
{
path: '/pagesH5/userSettings/chatSetting',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人设置","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-userSettings-chatSetting', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-chatSetting',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/chatSetting',
  windowTop:0
}
},
{
path: '/pagesH5/userSettings/customerInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"客户信息","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-userSettings-customerInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-customerInfo',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/customerInfo',
  windowTop:0
}
},
{
path: '/pagesH5/download/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智小伴","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-download-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-download-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/download/index',
  windowTop:0
}
},
{
path: '/pagesH5/userSettings/healthAndWellnessPlan',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"健康促进方案","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pagesH5-userSettings-healthAndWellnessPlan', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-healthAndWellnessPlan',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/healthAndWellnessPlan',
  windowTop:44
}
},
{
path: '/pagesH5/userSettings/healthReport',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"健康报告库","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pagesH5-userSettings-healthReport', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-healthReport',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/healthReport',
  windowTop:44
}
},
{
path: '/pagesH5/userSettings/planInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"方案详情","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pagesH5-userSettings-planInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-planInfo',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/planInfo',
  windowTop:44
}
},
{
path: '/pagesH5/userSettings/planContent',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"方案内容","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pagesH5-userSettings-planContent', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-planContent',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/planContent',
  windowTop:44
}
},
{
path: '/pagesH5/userSettings/qrcode',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationBarBackgroundColor":"#D9E8FC"})
      },
      [
        createElement('pagesH5-userSettings-qrcode', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-qrcode',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/qrcode',
  windowTop:44
}
},
{
path: '/pagesH5/userSettings/groupReport',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"出组报告","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pagesH5-userSettings-groupReport', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-groupReport',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/groupReport',
  windowTop:44
}
},
{
path: '/pagesH5/userSettings/facialAndTongueDiagnosis',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"面舌诊报告","navigationBarBackgroundColor":"#ffffff","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-userSettings-facialAndTongueDiagnosis', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-facialAndTongueDiagnosis',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/facialAndTongueDiagnosis',
  windowTop:0
}
},
{
path: '/pagesH5/userSettings/facialAndTongueDiagnosisTwo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"报告","navigationBarBackgroundColor":"#ffffff","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-userSettings-facialAndTongueDiagnosisTwo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-facialAndTongueDiagnosisTwo',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/facialAndTongueDiagnosisTwo',
  windowTop:0
}
},
{
path: '/pagesH5/wuYang/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationBarBackgroundColor":"#ffffff","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-wuYang-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-wuYang-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/wuYang/index',
  windowTop:0
}
},
{
path: '/pagesH5/userSettings/intelligentEvaluation',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智能测评报告","navigationBarBackgroundColor":"#ffffff","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-userSettings-intelligentEvaluation', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-intelligentEvaluation',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/intelligentEvaluation',
  windowTop:0
}
},
{
path: '/pagesH5/userSettings/reportList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智能测评报告","navigationBarBackgroundColor":"#ffffff","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-userSettings-reportList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-reportList',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/reportList',
  windowTop:0
}
},
{
path: '/pagesH5/plan/weightLoss',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"减脂减重计划","titleNView":false})
      },
      [
        createElement('pagesH5-plan-weightLoss', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-plan-weightLoss',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/plan/weightLoss',
  windowTop:0
}
},
{
path: '/pagesH5/plan/diet',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"饮食计划","titleNView":false})
      },
      [
        createElement('pagesH5-plan-diet', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-plan-diet',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/plan/diet',
  windowTop:0
}
},
{
path: '/pagesH5/orderConfirm/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"确认订单","titleNView":false})
      },
      [
        createElement('pagesH5-orderConfirm-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-orderConfirm-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/orderConfirm/index',
  windowTop:0
}
},
{
path: '/pagesH5/familyChart/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"家族图谱","titleNView":false})
      },
      [
        createElement('pagesH5-familyChart-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-familyChart-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/familyChart/index',
  windowTop:0
}
},
{
path: '/pagesH5/familyChart/addressBook',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"创建关系通讯录选择页","titleNView":false})
      },
      [
        createElement('pagesH5-familyChart-addressBook', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-familyChart-addressBook',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/familyChart/addressBook',
  windowTop:0
}
},
{
path: '/pagesH5/familyChart/selectRelationship',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"创建关系选择页","titleNView":false})
      },
      [
        createElement('pagesH5-familyChart-selectRelationship', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-familyChart-selectRelationship',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/familyChart/selectRelationship',
  windowTop:0
}
},
{
path: '/pagesH5/familyChart/editInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"关系网编辑信息","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-familyChart-editInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-familyChart-editInfo',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/familyChart/editInfo',
  windowTop:0
}
},
{
path: '/pagesH5/InviteFriends/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"邀请好友","titleNView":false})
      },
      [
        createElement('pagesH5-InviteFriends-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-InviteFriends-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/InviteFriends/index',
  windowTop:0
}
},
{
path: '/pagesH5/InviteFriends/addressBook',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"通讯录","titleNView":false})
      },
      [
        createElement('pagesH5-InviteFriends-addressBook', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-InviteFriends-addressBook',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/InviteFriends/addressBook',
  windowTop:0
}
},
{
path: '/pagesH5/demo/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"测试页面","titleNView":false})
      },
      [
        createElement('pagesH5-demo-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/index',
  windowTop:0
}
},
{
path: '/pagesH5/demo/alarm',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"血压报警","titleNView":false})
      },
      [
        createElement('pagesH5-demo-alarm', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-alarm',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/alarm',
  windowTop:0
}
},
{
path: '/pagesH5/demo/weight',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"体重","titleNView":false})
      },
      [
        createElement('pagesH5-demo-weight', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-weight',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/weight',
  windowTop:0
}
},
{
path: '/pagesH5/demo/familyHealth',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"家庭健康","titleNView":false})
      },
      [
        createElement('pagesH5-demo-familyHealth', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-familyHealth',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/familyHealth',
  windowTop:0
}
},
{
path: '/pagesH5/demo/play',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-demo-play', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-play',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/play',
  windowTop:0
}
},
{
path: '/pagesH5/demo/schedule',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"日程管理","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pagesH5-demo-schedule', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-schedule',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/schedule',
  windowTop:44
}
},
{
path: '/pagesH5/demo/kouQiang',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"口腔关爱计划"})
      },
      [
        createElement('pagesH5-demo-kouQiang', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-kouQiang',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/kouQiang',
  windowTop:44
}
},
{
path: '/pagesH5/demo/nuanXin',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"暖心护航保险计划"})
      },
      [
        createElement('pagesH5-demo-nuanXin', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-nuanXin',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/nuanXin',
  windowTop:44
}
},
{
path: '/pagesH5/demo/jianKang',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"健康关爱VIP体检计划"})
      },
      [
        createElement('pagesH5-demo-jianKang', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-jianKang',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/jianKang',
  windowTop:44
}
},
{
path: '/pagesH5/demo/pingPlay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"pingPlay"})
      },
      [
        createElement('pagesH5-demo-pingPlay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-pingPlay',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/pingPlay',
  windowTop:44
}
},
{
path: '/pagesH5/demo/jianYa',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"减压调理计划"})
      },
      [
        createElement('pagesH5-demo-jianYa', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-jianYa',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/jianYa',
  windowTop:44
}
},
{
path: '/pagesH5/demo/taskManage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"任务管理","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-demo-taskManage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-taskManage',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/taskManage',
  windowTop:0
}
},
{
path: '/pagesH5/demo/userPortrait',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户画像","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-demo-userPortrait', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-userPortrait',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/userPortrait',
  windowTop:0
}
},
{
path: '/pagesH5/demo/bloodResultPop',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"血压测量","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-demo-bloodResultPop', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-demo-bloodResultPop',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/demo/bloodResultPop',
  windowTop:0
}
},
{
path: '/pagesH5/hardware/resultPressure',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"硬件压力测量结果","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-hardware-resultPressure', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-hardware-resultPressure',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/hardware/resultPressure',
  windowTop:0
}
},
{
path: '/pagesH5/registration/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预约挂号","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-registration-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-registration-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/registration/index',
  windowTop:0
}
},
{
path: '/pagesH5/registration/recommendedDoctor',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"医生推荐","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-registration-recommendedDoctor', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-registration-recommendedDoctor',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/registration/recommendedDoctor',
  windowTop:0
}
},
{
path: '/pagesH5/aiReasoning/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"AI推理过程","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-aiReasoning-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-aiReasoning-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/aiReasoning/index',
  windowTop:0
}
},
{
path: '/pagesH5/registration/visitor',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"就诊人管理","navigationBarBackgroundColor":"#EBEBEB"})
      },
      [
        createElement('pagesH5-registration-visitor', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-registration-visitor',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/registration/visitor',
  windowTop:44
}
},
{
path: '/pagesH5/registration/visitorAdd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"编辑就诊人信息","titleNView":false})
      },
      [
        createElement('pagesH5-registration-visitorAdd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-registration-visitorAdd',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/registration/visitorAdd',
  windowTop:0
}
},
{
path: '/pagesH5/registration/customInfoEdit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","titleNView":false})
      },
      [
        createElement('pagesH5-registration-customInfoEdit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-registration-customInfoEdit',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/registration/customInfoEdit',
  windowTop:0
}
},
{
path: '/pagesH5/registration/signing',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"签约","titleNView":false})
      },
      [
        createElement('pagesH5-registration-signing', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-registration-signing',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/registration/signing',
  windowTop:0
}
},
{
path: '/pagesH5/appointment/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的预约","navigationBarBackgroundColor":"#FFF"})
      },
      [
        createElement('pagesH5-appointment-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-appointment-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/appointment/index',
  windowTop:44
}
},
{
path: '/pagesH5/medicalExaminationReport/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"体检报告","navigationBarBackgroundColor":"#FFF","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-medicalExaminationReport-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-medicalExaminationReport-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/medicalExaminationReport/index',
  windowTop:0
}
},
{
path: '/pagesH5/intelligentReservation/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智能预约","navigationBarBackgroundColor":"#FFF","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-intelligentReservation-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-intelligentReservation-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/intelligentReservation/index',
  windowTop:0
}
},
{
path: '/pagesH5/intelligentReservation/search',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智能预约","navigationBarBackgroundColor":"#FFF"})
      },
      [
        createElement('pagesH5-intelligentReservation-search', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-intelligentReservation-search',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/intelligentReservation/search',
  windowTop:44
}
},
{
path: '/pagesH5/userSettings/aboutUs',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"关于我们","navigationBarBackgroundColor":"#FFF"})
      },
      [
        createElement('pagesH5-userSettings-aboutUs', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-aboutUs',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/aboutUs',
  windowTop:44
}
},
{
path: '/pagesH5/userSettings/cancelAccount',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注销账号","navigationBarBackgroundColor":"#FFF"})
      },
      [
        createElement('pagesH5-userSettings-cancelAccount', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-cancelAccount',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/cancelAccount',
  windowTop:44
}
},
{
path: '/pagesH5/userSettings/cancellation',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注销账号","navigationBarBackgroundColor":"#FFF"})
      },
      [
        createElement('pagesH5-userSettings-cancellation', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-userSettings-cancellation',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/userSettings/cancellation',
  windowTop:44
}
},
{
path: '/pagesH5/interventionPlan/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"干预计划","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-interventionPlan-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-interventionPlan-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/interventionPlan/index',
  windowTop:0
}
},
{
path: '/pagesH5/evaluating/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"评测","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-evaluating-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-evaluating-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/evaluating/index',
  windowTop:0
}
},
{
path: '/pagesH5/evaluating/report',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"您的专属减重计划","navigationStyle":"custom"})
      },
      [
        createElement('pagesH5-evaluating-report', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-evaluating-report',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/evaluating/report',
  windowTop:0
}
},
{
path: '/pagesH5/evaluating/reportDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"报告详情","navigationBarBackgroundColor":"#DBFEFD"})
      },
      [
        createElement('pagesH5-evaluating-reportDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-evaluating-reportDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/evaluating/reportDetail',
  windowTop:44
}
},
{
path: '/pagesH5/videoPlay/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pagesH5-videoPlay-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesH5-videoPlay-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesH5/videoPlay/index',
  windowTop:44
}
},
{
path: '/pagesFriend/addressBook/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"通讯录","navigationStyle":"custom","navigationBarBackgroundColor":"#EDEDED"})
      },
      [
        createElement('pagesFriend-addressBook-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesFriend-addressBook-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesFriend/addressBook/index',
  windowTop:0
}
},
{
path: '/pagesFriend/addressBook/groupList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"群聊列表","navigationBarBackgroundColor":"#EDEDED"})
      },
      [
        createElement('pagesFriend-addressBook-groupList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesFriend-addressBook-groupList',
  isNVue:false,maxWidth:0,
  pagePath:'pagesFriend/addressBook/groupList',
  windowTop:44
}
},
{
path: '/pagesFriend/notification/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"好友申请通知","navigationBarBackgroundColor":"#fff"})
      },
      [
        createElement('pagesFriend-notification-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesFriend-notification-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesFriend/notification/index',
  windowTop:44
}
},
{
path: '/pagesFriend/addFriends/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加朋友","navigationBarBackgroundColor":"#fff"})
      },
      [
        createElement('pagesFriend-addFriends-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesFriend-addFriends-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesFriend/addFriends/index',
  windowTop:44
}
},
{
path: '/pagesFriend/addFriends/info',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加朋友","navigationBarBackgroundColor":"#d9e8fc"})
      },
      [
        createElement('pagesFriend-addFriends-info', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesFriend-addFriends-info',
  isNVue:false,maxWidth:0,
  pagePath:'pagesFriend/addFriends/info',
  windowTop:44
}
},
{
path: '/pagesFriend/addFriends/applay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请添加朋友"})
      },
      [
        createElement('pagesFriend-addFriends-applay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesFriend-addFriends-applay',
  isNVue:false,maxWidth:0,
  pagePath:'pagesFriend/addFriends/applay',
  windowTop:44
}
},
{
path: '/pagesMonitor/monitor/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"日常监测","navigationBarBackgroundColor":"#D9E8FC","navigationStyle":"custom"})
      },
      [
        createElement('pagesMonitor-monitor-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/index',
  windowTop:0
}
},
{
path: '/pagesMonitor/monitor/add-blood-pressure',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"记录血压心率","navigationBarBackgroundColor":"#D9E8FC","navigationStyle":"custom"})
      },
      [
        createElement('pagesMonitor-monitor-add-blood-pressure', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-add-blood-pressure',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/add-blood-pressure',
  windowTop:0
}
},
{
path: '/pagesMonitor/monitor/add-blood-sugar',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"记录血糖","navigationBarBackgroundColor":"#D9E8FC","navigationStyle":"custom"})
      },
      [
        createElement('pagesMonitor-monitor-add-blood-sugar', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-add-blood-sugar',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/add-blood-sugar',
  windowTop:0
}
},
{
path: '/pagesMonitor/monitor/add-drug',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加口服药/胰岛素","navigationBarBackgroundColor":"#D9E8FC"})
      },
      [
        createElement('pagesMonitor-monitor-add-drug', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-add-drug',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/add-drug',
  windowTop:44
}
},
{
path: '/pagesMonitor/monitor/add-medicine',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加用药"})
      },
      [
        createElement('pagesMonitor-monitor-add-medicine', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-add-medicine',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/add-medicine',
  windowTop:44
}
},
{
path: '/pagesMonitor/monitor/edit-baseinfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"记录基本信息","navigationBarBackgroundColor":"#D9E8FC"})
      },
      [
        createElement('pagesMonitor-monitor-edit-baseinfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-edit-baseinfo',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/edit-baseinfo',
  windowTop:44
}
},
{
path: '/pagesMonitor/monitor/add-weight',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"记录体重","navigationBarBackgroundColor":"#D9E8FC","navigationStyle":"custom"})
      },
      [
        createElement('pagesMonitor-monitor-add-weight', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-add-weight',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/add-weight',
  windowTop:0
}
},
{
path: '/pagesMonitor/monitor/add-waist',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"记录体围","navigationBarBackgroundColor":"#D9E8FC"})
      },
      [
        createElement('pagesMonitor-monitor-add-waist', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-add-waist',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/add-waist',
  windowTop:44
}
},
{
path: '/pagesMonitor/monitor/add-urine-monitor',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"日常检测","navigationBarBackgroundColor":"#D9E8FC","navigationStyle":"custom"})
      },
      [
        createElement('pagesMonitor-monitor-add-urine-monitor', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-add-urine-monitor',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/add-urine-monitor',
  windowTop:0
}
},
{
path: '/pagesMonitor/monitor/record-list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"历史记录","navigationBarBackgroundColor":"#F6F7F8","navigationStyle":"custom"})
      },
      [
        createElement('pagesMonitor-monitor-record-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-record-list',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/record-list',
  windowTop:0
}
},
{
path: '/pagesMonitor/monitor/device/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"设备配置","navigationBarBackgroundColor":"#D9E8FC"})
      },
      [
        createElement('pagesMonitor-monitor-device-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-device-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/device/index',
  windowTop:44
}
},
{
path: '/pagesMonitor/monitor/device/measure',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"体重测量","navigationBarBackgroundColor":"#D9E8FC"})
      },
      [
        createElement('pagesMonitor-monitor-device-measure', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-device-measure',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/device/measure',
  windowTop:44
}
},
{
path: '/pagesMonitor/monitor/result/body-girth',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"体围结果","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pagesMonitor-monitor-result-body-girth', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-result-body-girth',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/result/body-girth',
  windowTop:44
}
},
{
path: '/pagesMonitor/monitor/result/weight',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"体重结果","navigationBarBackgroundColor":"#EDF5FD"})
      },
      [
        createElement('pagesMonitor-monitor-result-weight', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-result-weight',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/result/weight',
  windowTop:44
}
},
{
path: '/pagesMonitor/monitor/result/bodyMetrics',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"身体指标","navigationBarBackgroundColor":"#EDF5FD","navigationStyle":"custom"})
      },
      [
        createElement('pagesMonitor-monitor-result-bodyMetrics', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-result-bodyMetrics',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/result/bodyMetrics',
  windowTop:0
}
},
{
path: '/pagesMonitor/monitor/result/blood-weight',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"体重结果","navigationBarBackgroundColor":"#EDF5FD","navigationStyle":"custom"})
      },
      [
        createElement('pagesMonitor-monitor-result-blood-weight', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-result-blood-weight',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/result/blood-weight',
  windowTop:0
}
},
{
path: '/pagesMonitor/monitor/result/blood-sugar',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"血糖解读","navigationBarBackgroundColor":"#fff"})
      },
      [
        createElement('pagesMonitor-monitor-result-blood-sugar', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-result-blood-sugar',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/result/blood-sugar',
  windowTop:44
}
},
{
path: '/pagesMonitor/monitor/result/blood-pressure',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"血压结果","navigationBarBackgroundColor":"#fff"})
      },
      [
        createElement('pagesMonitor-monitor-result-blood-pressure', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMonitor-monitor-result-blood-pressure',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMonitor/monitor/result/blood-pressure',
  windowTop:44
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
